document.addEventListener('DOMContentLoaded', function () {
  attachQuoteButtons();
  updateQuoteCount();
});

function attachQuoteButtons() {
  var buttons = document.querySelectorAll('.js-add-to-quote-btn');

  buttons.forEach(function (btn) {
    if (btn.dataset.quoteBound) return;
    btn.dataset.quoteBound = 'true';

    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;

      var qtyInput = btn.closest('form') ? btn.closest('form').querySelector('input[name="quantity"]') : null;
      var quantity = qtyInput ? parseInt(qtyInput.value) : 1;

      var item = {
        variantId: variantId,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        sku: btn.dataset.productSku,
        url: btn.dataset.productUrl,
        quantity: quantity
      };

      var quoteList = JSON.parse(localStorage.getItem('quoteCart') || '[]');
      var existing = quoteList.find(function (i) { return i.variantId === item.variantId; });
      if (existing) { existing.quantity += quantity; } else { quoteList.push(item); }

      localStorage.setItem('quoteCart', JSON.stringify(quoteList));
      updateQuoteCount();

      // Redirect straight to the Quote Cart page after adding
      window.location.href = '/pages/request-a-quote';
    });
  });
}

function updateQuoteCount() {
  var quoteList = JSON.parse(localStorage.getItem('quoteCart') || '[]');
  var countEl = document.getElementById('QuoteCartCount');
  if (countEl) countEl.textContent = quoteList.length;
}